module.exports = __webpack_public_path__ + "img/donante-radioformula.8e0ab232.png";